<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang="less">
html,
body,
#app {
  // text-align: center;
  width: 100%;
  height: 100%;
}
body {
  // background: #f6f6f6 !important;
  font-size: 14px;
  // background-color: #f5f5f8 !important;
}
.main-inner {
  background: #fff;
}
</style>
